module.exports = __webpack_public_path__ + "static/media/slide1.65bb26da.svg";